module.exports = __webpack_public_path__ + "img/taili(3).775427a3.jpg";